import axiosInstance from '@src/axios';
import { ApplyFormType } from '@src/stores/4cut-ranking/applyStore';

// 포토 카드의 원본 사진 업로드 API
const postOriginPhoto = async (
  data: FormData,
): Promise<AInstance.Res<{ uploadedPath: string }>> =>
  axiosInstance.post('/api/ranking/v2/photo-cards/photos/origin', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// 포토 카드의 썸네일 사진 업로드 API
const postThumbnailPhoto = async (
  data: FormData,
): Promise<AInstance.Res<{ uploadedPath: string }>> =>
  axiosInstance.post('/api/ranking/v2/photo-cards/photos/thumbnail', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// 포토 카드 생성 API
const postPhotoCard = async (
  data: ApplyFormType,
): Promise<AInstance.Res<PhotoCardType>> =>
  axiosInstance.post('/api/ranking/v2/photo-cards', data);

// 포토 카드 ID에 해당하는 포토 카드 상세 정보 조회 API
const getPhotoCardDetail = async (params: {
  photoCardId: string;
}): Promise<AInstance.Res<PhotoCardType>> =>
  axiosInstance.get(`/api/ranking/v2/photo-cards/${params.photoCardId}`);

// 이미지 EXIF의 sessionId 값을 통해 포토카드 업로드 가능 여부를 확인하는 API
const getExifValidation = async (params: {
  sessionId: string;
}): Promise<
  AInstance.Res<{
    valid: boolean;
  }>
> =>
  axiosInstance.get('/api/ranking/v2/photo-cards/validate', {
    params,
  });

// 포토 카드 신고하기 API
const postReportPhotoCard = async (params: {
  cause: string;
  detailCause: string;
  photoCardId: string;
}): Promise<AInstance.DefaultRes> => {
  return axiosInstance.post('/api/ranking/v2/photo-cards/report', params);
};

// 명예의 전당 일자에 해당하는 포토카드 조회 API
const getHallOfFameCards = async (params: {
  startDateTime: string;
  endDateTime: string;
  photoCardCategory: CategoryType;
}): Promise<AInstance.Res<PhotoCardType[]>> => {
  return axiosInstance.get('/api/ranking/v2/photo-cards/hall-of-fame', {
    params,
  });
};

// 내 포토 카드 조회 API
const getMyPhotoCards = async (params: {
  page: number;
  size: number;
  sort: string;
}): Promise<AInstance.Res<PageResultType<PhotoCardType>>> =>
  axiosInstance.get('/api/ranking/v2/photo-cards/me', { params });

// 다른 회원 포토 카드 조회 API
const getOtherUserPhotoCards = async (params: {
  userId: string;
  page: number;
  size: number;
  sort: string;
}): Promise<AInstance.Res<PageResultType<PhotoCardType>>> =>
  axiosInstance.get(`/api/ranking/v2/photo-cards/users/${params.userId}`, {
    params,
  });

// 내 포토 카드 삭제 API
const deleteMyPhotoCard = async (params: {
  photoCardId: string;
}): Promise<AInstance.DefaultRes> =>
  axiosInstance.delete(`/api/ranking/v2/photo-cards/me/${params.photoCardId}`);

// 실시간 랜덤 포토카드
const getHotPhotoCardRandom = async (
  params: {
    region?: RankingRegionType;
  } = {},
): Promise<AInstance.Res<PhotoCardType[]>> => {
  return axiosInstance.get('/api/ranking/v2/games/hot/random', {
    params,
  });
};

const patchPhotoCardRejectedList = async (): Promise<
  AInstance.Res<PhotoCardType[]>
> => axiosInstance.patch('/api/ranking/v2/photo-cards/me/rejected');

export default {
  postOriginPhoto,
  postThumbnailPhoto,
  postPhotoCard,
  getPhotoCardDetail,
  getExifValidation,
  postReportPhotoCard,
  getHallOfFameCards,
  getMyPhotoCards,
  getOtherUserPhotoCards,
  deleteMyPhotoCard,
  getHotPhotoCardRandom,
  patchPhotoCardRejectedList,
};
